import { GetOwnIntakeQuery_getOwnIntake } from '../../../schema/schemaTypes'
import { IIntakeMetrics } from './IIntakeMetrics'

export function intakeMetrics (i: GetOwnIntakeQuery_getOwnIntake): IIntakeMetrics {
  if (i === null || i === undefined) {
    return {
      parentReligiosity: 'L',
      childAnxiety: 'H',
      intake1Started: false,
      intake2Started: false,
      intake3AllUnsureDontKnow: false,
      intake3Started: false,
      parentAnxiety: 'H',
      parentCoping: 'B',
      parentFamilioso: 'L',
      parentSimpatia: 'L',
      parentAnxietyCoping: '',
      surgeryOptions: '',
      section1Started: false,
      section2Started: false,
      section3Started: false,
      section4Started: false,
      section4ReviewCompleted: false,
      furthestContentPage: '',
      furthestWebinfoPage: '',
      hasAcceptedDisclaimer: false,
    }
  }
  return {
    childAnxiety: childAnxiety(i),
    intake1Started: intake1Started(i),
    intake2Started: intake2Started(i),
    intake3AllUnsureDontKnow: intake3AllUnsureDontKnow(i),
    intake3Started: intake3Started(i),
    parentAnxiety: parentAnxiety(i),
    parentCoping: parentCoping(i),
    parentReligiosity: parentReligiosity(i),
    parentFamilioso: parentFamilismo(i),
    parentSimpatia: parentSimpatia(i),
    parentAnxietyCoping: parentAnxietyCoping(i),
    surgeryOptions: surgeryOptions(i),
    section1Started: section1Started(i),
    section2Started: section2Started(i),
    section3Started: section3Started(i),
    section4Started: section4Started(i),
    section4ReviewCompleted: section4ReviewCompleted(i),
    furthestContentPage: getFurthestPage(i),
    furthestWebinfoPage: getFurthestWebinfoPage(i),
    hasAcceptedDisclaimer: getHasAcceptedDisclaimer(i),
  }
}

function section4ReviewCompleted(i: GetOwnIntakeQuery_getOwnIntake) {
  return (i.review4AllTrueAboutManagingChildsPainAtHomeExcept !== null)
  // return section4Started(i)
}

function section1Started(i: GetOwnIntakeQuery_getOwnIntake) {
  return (i && i.childSportsOrExtracurricular !== null)
}

function section2Started(i: GetOwnIntakeQuery_getOwnIntake) {
  return (i.surgeryType !== null)
}

function section3Started(i: GetOwnIntakeQuery_getOwnIntake) {
  return (i.review2ImportantOneParentInLobby !== null)
}

function section4Started(i: GetOwnIntakeQuery_getOwnIntake) {
  return ( i.painMedsExpressCryingWhining !== null)
}

function childAnxiety (i: GetOwnIntakeQuery_getOwnIntake) {
  if (i.childAfraidOfBurglars === null || i.childAfraidOfLoudNoises === null || i.childNotAfraidOfTheDark === null ||
    i.childAfraidOfFire === null || i.childAfraidOfTheDark === null || i.childRarelyAfraidMonsters === null) {
    return 'H'
  }

  return (
    i.childAfraidOfBurglars +
    i.childAfraidOfLoudNoises +
    8 - i.childNotAfraidOfTheDark +
    i.childAfraidOfFire +
    i.childAfraidOfTheDark +
    8 - i.childRarelyAfraidMonsters
  ) / 6.0 > 3.99 ? 'H' : 'L'
}

function getFurthestWebinfoPage(i: GetOwnIntakeQuery_getOwnIntake) {
  return i.furthestWebinfoPage || ''
}

function getFurthestPage(i: GetOwnIntakeQuery_getOwnIntake) {
  return i.furthestContentPage || ''
}

function getHasAcceptedDisclaimer(i: GetOwnIntakeQuery_getOwnIntake) {
  return i.hasAcceptedDisclaimer || false
}

function intake1Started (i: GetOwnIntakeQuery_getOwnIntake) {
  // if (i.childFirstName !== null) { return true }
  // if (i.childLastName !== null) { return true }
  // if (i.childNickname !== null) { return true }
  // if (i.childDateOfBirth !== null) { return true }
  if (i.childGender !== null) { return true }
  if (i.childHadGeneralAnesthesia !== null) { return true }
  if (i.childHandledGeneralAnesthesia !== null) { return true }
  if (i.childHandledLastMedicalEncounter !== null) { return true }
  if (i.checkedChildReactionsText !== null) { return true }
  if (i.childAfraidOfBurglars !== null) { return true }
  if (i.childAfraidOfLoudNoises !== null) { return true }
  if (i.childNotAfraidOfTheDark !== null) { return true }
  if (i.childAfraidOfFire !== null) { return true }
  if (i.childAfraidOfTheDark !== null) { return true }
  if (i.childRarelyAfraidMonsters !== null) { return true }
  if (i.checkedParentInfoText !== null) { return true }
  if (i.parentAge !== null) { return true }
  if (i.parentRole !== null) { return true }
  if (i.parentAnxiousness !== null) { return true }
  if (i.checkedParentDescribeText !== null) { return true }
  if (i.parentFeelPleasant !== null) { return true }
  if (i.parentTireQuickly !== null) { return true }
  if (i.parentFeelCrying !== null) { return true }
  if (i.parentWishCouldBeHappy !== null) { return true }
  if (i.parentLoosingOut !== null) { return true }
  if (i.parentFeelRested !== null) { return true }
  if (i.parentAmCalmCoolCollected !== null) { return true }
  if (i.parentDifficultiesNotOvercome !== null) { return true }
  if (i.parentWorryTooMuch !== null) { return true }
  if (i.parentAmHappy !== null) { return true }
  if (i.parentTakeThingsHard !== null) { return true }
  if (i.parentLackSelfConfidence !== null) { return true }
  if (i.parentFeelSecure !== null) { return true }
  if (i.parentAvoidCrisis !== null) { return true }
  if (i.parentFeelBlue !== null) { return true }
  if (i.parentAmContent !== null) { return true }
  if (i.parentUnimportantThoughtsBother !== null) { return true }
  if (i.parentTakeDisappointmentsTooKeenly !== null) { return true }
  if (i.parentTensionAndTurmoil !== null) { return true }
  if (i.parentSteadyPerson !== null) { return true }
  if (i.parentDentistAsk !== null) { return true }
  if (i.parentDentistTranquilizerOrDrink !== null) { return true }
  if (i.parentDentistThinkPleasant !== null) { return true }
  if (i.parentDentistTellMeAboutPain !== null) { return true }
  if (i.parentDentistTrySleep !== null) { return true }
  if (i.parentDentistWatchMovementsAndListenDrill !== null) { return true }
  if (i.parentDentistWatchForBlood !== null) { return true }
  if (i.parentDentistMentalPuzzles !== null) { return true }
  if (i.parentPlaneReadEmergency !== null) { return true }
  if (i.parentPlaneSmallTalk !== null) { return true }
  if (i.parentPlaneWatchMovie !== null) { return true }
  if (i.parentPlaneAskFlightAttendant !== null) { return true }
  if (i.parentPlaneTranquilizerOrDrink !== null) { return true }
  if (i.parentPlaneListenEnginesAndCrew !== null) { return true }
  if (i.parentPlaneTalkAboutIssue !== null) { return true }
  if (i.parentPlaneReadOrWrite !== null) { return true }
  if (i.childFavoriteToys !== null) { return true }
  if (i.childFavoriteGames !== null) { return true }
  if (i.childEnjoysMovies !== null) { return true }
  if (i.childPets !== null) { return true }
  if (i.childSportsOrExtracurricular !== null) { return true }

  return false
}

function intake2Started (i: GetOwnIntakeQuery_getOwnIntake) {
  if (i.surgeryType !== null) { return true }
  if (i.surgeryOptionsBeWithChild !== null) { return true }
  if (i.surgeryOptionsReceiveSedative !== null) { return true }
  if (i.surgeryOptionsNeither !== null) { return true }

  return false
}

/*function pabloStarted (i: GetOwnIntakeQuery_getOwnIntake) {
  
  if (i.characterChoice !== null) { return true }
  if (i.surgeryOptionsBeWithChild !== null) { return true }
  if (i.surgeryOptionsReceiveSedative !== null) { return true }
  if (i.surgeryOptionsNeither !== null) { return true }

  return false
}*/

function intake3Started (i: GetOwnIntakeQuery_getOwnIntake) {
  if (i.checkedPainMedsInfoText !== null) { return true }
  if (i.painMedsWorrySideEffects !== null) { return true }
  if (i.painMedsConcernedAddictionAbuse !== null) { return true }
  if (i.painMedsWorksBestRarelyWorst !== null) { return true }
  if (i.painMedsChildrenFeelLessPain !== null) { return true }
  if (i.painMedsExpressCryingWhining !== null) { return true }

  return false
}

function intake3AllUnsureDontKnow (i: GetOwnIntakeQuery_getOwnIntake) {
  if (i.painMedsWorrySideEffects !== 3) { return false }
  if (i.painMedsConcernedAddictionAbuse !== 3) { return false }
  if (i.painMedsWorksBestRarelyWorst !== 3) { return false }
  if (i.painMedsChildrenFeelLessPain !== 3) { return false }
  if (i.painMedsExpressCryingWhining !== 3) { return false }

  return true
}

function parentAnxiety (i: GetOwnIntakeQuery_getOwnIntake) {
  if (i.parentFeelPleasant === null ||
    i.parentAmCalmCoolCollected === null || i.parentDifficultiesNotOvercome === null ||
    i.parentWorryTooMuch === null || i.parentAmHappy === null || i.parentTakeThingsHard === null ||
    i.parentFeelSecure === null || i.parentFeelBlue === null || i.parentAmContent === null ||
    i. parentTakeDisappointmentsTooKeenly === null || i.parentSteadyPerson === null) { return 'H' }

  const scores = [
    5 - i.parentFeelPleasant,
    5 - i.parentAmCalmCoolCollected,
    i.parentDifficultiesNotOvercome,
    i.parentWorryTooMuch,
    5 - i.parentAmHappy,
    i.parentTakeThingsHard,
    5 - i.parentFeelSecure,
    i.parentFeelBlue,
    5 - i.parentAmContent,
    i. parentTakeDisappointmentsTooKeenly,
    5 - i.parentSteadyPerson,
  ]

  const sum = scores.reduce((a,b) => a + b, 0)

  return sum >= 24  ? 'H' : 'L'
}

function parentReligiosity (i: GetOwnIntakeQuery_getOwnIntake) {
  if (i.religousQ1 === null ||
    i.religousQ2 === null || i.religousQ3 === null ||
    i.religousQ3 === null || i.religousQ4 === null || i.religousQ5 === null ||
    i.religousQ6 === null || i.religousQ7 === null) { return 'H' }

  const scores = [
    i.religousQ1,
    i.religousQ2,
    i.religousQ3,
    i.religousQ4,
    i.religousQ5,
    i.religousQ6,
    i.religousQ7,
  ]

  const sum = scores.reduce((a,b) => a + b, 0)


  return sum >= 15 ? 'H' : 'L'
}

function parentSimpatia (i: GetOwnIntakeQuery_getOwnIntake){
  if (i.parentShareFeelings === null ||
    i.parentRespectOthers === null || i.parentAvoidConflict === null ||
    i.parentControlEmotions === null || i.parentShowLoyalty === null || i.parentObeyWishes === null ||
    i.parentShowAgreement === null || i.parentGoodManners === null ||
    i.parentFeelComfortable === null || i.parentAvoidRudeness === null)  { return 'L' }

  const scores = [
    i.parentShareFeelings,
    i.parentRespectOthers,
    i.parentAvoidConflict,
    i.parentControlEmotions,
    i.parentShowLoyalty,
    i.parentShowAgreement,
    i.parentGoodManners,
    i.parentObeyWishes,
    i.parentFeelComfortable,
    i.parentAvoidRudeness,
  ]

  const sum = scores.reduce((a,b) => a + b, 0)


  return sum >= 27 ? 'H' : 'L'
}

function parentFamilismo (i: GetOwnIntakeQuery_getOwnIntake){
  if (i.parentMakeSacrifices === null ||
    i.parentHasProblems === null || i.wouldHelpRelatives === null ||
    i.shouldLiveLong === null || i.agingParents === null || i.shouldShareWithRelatives === null ||
    i.canCountOnRelative === null || i.helpEconomically === null || i.shouldBeEmbarrassed === null
    || i.shouldPleaseParents === null || i.familyShouldConsult === null || i.shouldLiveInParentsHouse === null || i.goalToHaveChildren === null) { return 'L' }

  const scores = [
    i.parentMakeSacrifices,
    i.parentHasProblems,
    i.wouldHelpRelatives,
    i.shouldLiveLong,
    i.agingParents,
    i.shouldShareWithRelatives,
    i.canCountOnRelative,
    i.helpEconomically,
    i.shouldBeEmbarrassed,
    i.shouldPleaseParents,
    i.familyShouldConsult,
    i.canCountOnRelative,
    i.shouldLiveInParentsHouse,
    i.goalToHaveChildren,
  ]

  const sum = scores.reduce((a,b) => a + b, 0)


  return sum >= 25 ? 'H' : 'L'
}

function parentCoping (i: GetOwnIntakeQuery_getOwnIntake) {
  if (i.parentDentistAsk === null || i.parentDentistTellMeAboutPain === null ||
    i.parentDentistWatchMovementsAndListenDrill === null || i.parentDentistWatchForBlood === null ||
    i.parentPlaneReadEmergency === null || i.parentPlaneAskFlightAttendant === null ||
    i.parentPlaneListenEnginesAndCrew === null || i.parentPlaneTalkAboutIssue === null ||
    i.parentDentistTranquilizerOrDrink === null || i.parentDentistThinkPleasant === null ||
    i.parentDentistTrySleep === null || i.parentDentistMentalPuzzles === null || i.parentPlaneSmallTalk === null ||
    i.parentPlaneWatchMovie === null || i.parentPlaneTranquilizerOrDrink === null ||
    i.parentPlaneReadOrWrite === null) { return 'B' }

  const monitoringScore = countTrue(i.parentDentistAsk, i.parentDentistTellMeAboutPain,
    i.parentDentistWatchMovementsAndListenDrill, i.parentDentistWatchForBlood, i.parentPlaneReadEmergency,
    i.parentPlaneAskFlightAttendant, i.parentPlaneListenEnginesAndCrew, i.parentPlaneTalkAboutIssue)

  const blunterScore = countTrue(i.parentDentistTranquilizerOrDrink, i.parentDentistThinkPleasant,
    i.parentDentistTrySleep, i.parentDentistMentalPuzzles, i.parentPlaneSmallTalk, i.parentPlaneWatchMovie,
    i.parentPlaneTranquilizerOrDrink, i.parentPlaneReadOrWrite)

    return (monitoringScore - blunterScore) >= 4 ? 'M' : 'B'
}

function countTrue(...args: boolean[]) {
  return args.map(arg => arg ? 1 : 0).reduce((prev, cur) => prev + cur, 0)
}

function parentAnxietyCoping(i: GetOwnIntakeQuery_getOwnIntake) {
  return parentAnxiety(i) + parentCoping(i)
}

function surgeryOptions(i: GetOwnIntakeQuery_getOwnIntake) {
  let options = ''
  if (i.surgeryOptionsNeither) {
    options = 'N'
  } else {
    if (i.surgeryOptionsBeWithChild) {
      options = 'P'
    } if (i.surgeryOptionsReceiveSedative) {
      options = options + 'M'
    }
  }
  return options
}

export function patientInfo (i: GetOwnIntakeQuery_getOwnIntake) {
  const ca = childAnxiety(i)
  const pa = parentAnxietyCoping(i)
  const pc = surgeryOptions(i)
  const pr = parentReligiosity(i)
  const pf = parentFamilismo(i)
  const ps = parentSimpatia(i)

  let parentWillingText = ''
  let parentAnxietyText = ''
  let childAnxietyText = ''
  let parentFamilismoText = ''
  let parentSimpatiaText = ''
  let parentReligiosityText = ''

  if(pc === 'PM') {
    parentWillingText = 'During the WebTIPS intake, the parent indicated they would prefer to be present ' +
      'for their child\'s anesthesia induction and would like their child to receive a sedative premedication.'
  }
  if(pc === 'P') {
    parentWillingText = 'During the WebTIPS intake, the parent indicated they would prefer to be present for ' +
      'their child\'s anesthesia induction and would not like their child to receive a sedative premedication.'
  }
  if(pc === 'M') {
    parentWillingText = 'During the WebTIPS intake, the parent indicated they would prefer not to be present ' +
      'for their child\'s anesthesia induction and would like their child to receive a sedative premedication.'
  }
  if(pc === 'N') {
    parentWillingText = 'During the WebTIPS intake, the parent indicated they would prefer not to be present ' +
      'for their child\'s anesthesia induction and would not like their child to receive a sedative premedication.'
  }
  if(pa === 'HM') {
    parentAnxietyText = 'Parent tends to be highly anxious and prefers to be provided with a lot of information ' +
      'about medical procedures.'
  }
  if(pa === 'LM') {
    parentAnxietyText = 'Parent tends not to be anxious and prefers to be provided with a lot of information about ' +
      'medical procedures.'
  }
  if(pa === 'HB') {
    parentAnxietyText = 'Parent tends to be highly anxious and prefers minimal information about medical procedures.'
  }
  if(pa === 'LB') {
    parentAnxietyText = 'Parent tends not to be anxious and prefers minimal information about medical procedures.'
  }
  if(ca === 'H') {
    childAnxietyText = 'Parent reported their child tends to be very anxious about medical procedures.'
  }
  if(ca === 'L') {
    childAnxietyText = 'Parent reported their child tends not to be anxious about medical procedures.'
  }

  if(pr === 'H'){
    parentReligiosityText = 'Parent reported high religiosity. High endorsement of Religiosity may lead individuals to turn to religious and spiritual beliefs, teachings, and practices as a means for coping with stressors and difficulties of life.'
  }

  if(pf === 'H') {
    parentFamilismoText = 'Parent reported high endorsement of simpatia. This is a Latino cultural value emphasizing pleasantness and harmony in social interaction.'
  }

  if(ps === 'H'){
    parentSimpatiaText = 'Parent reported high endorsement of familism. This is a Latino cultural value emphasizing strong value for close and supportive family relationships.'
  }

  return {
    parentWillingText,
    parentAnxietyText,
    childAnxietyText,
    parentFamilismoText,
    parentSimpatiaText,
    parentReligiosityText,
  }
}



// WEBPACK FOOTER //
// ./src/organisms/Intakes/intakeMetrics/calcIntakeMetrics.ts